/* Print Phuket Design Studio: view toggles, expertise tabs, concept-to-print stepper, scroll reveal. Content is fully visible without JS. */
(function(){
  var root=document.querySelector('.ppd');if(!root)return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // sticky intros sit below the theme's sticky header
  var setTop=function(){var b=0;document.querySelectorAll('.shopify-section-group-header-group').forEach(function(e){if(getComputedStyle(e).position==='sticky'){var r=e.getBoundingClientRect();if(r.bottom>b&&r.top<=1+b)b=r.bottom;}});root.querySelectorAll('.ppd-services__intro,.ppd-faq__intro').forEach(function(el){el.style.top=Math.round(b+32)+'px';});};
  setTop();window.addEventListener('resize',setTop,{passive:true});

  // Design / Print view toggles (hero artboard + gallery)
  function bindSeg(seg,target){
    if(!seg||!target)return;
    seg.addEventListener('click',function(e){
      var b=e.target.closest('button[data-view]');if(!b)return;
      seg.querySelectorAll('button').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false');});
      target.classList.toggle('is-print',b.getAttribute('data-view')==='print');
      target._ppdTouched=true;
    });
  }
  var board=root.querySelector('[data-ppd-board]');
  if(board)bindSeg(board.querySelector('.ppd-seg'),board);
  var work=root.querySelector('[data-ppd-work]');
  if(work)bindSeg(work.querySelector('.ppd-seg'),work);
  // gentle demo: flip the hero artboard to print view once, then back, unless the visitor has used it
  if(board&&!reduce){
    var seg=board.querySelector('.ppd-seg');
    var flip=function(v){if(board._ppdTouched)return;board.classList.toggle('is-print',v==='print');seg.querySelectorAll('button').forEach(function(x){x.setAttribute('aria-pressed',x.getAttribute('data-view')===v?'true':'false');});};
    setTimeout(function(){flip('print');},2600);
    setTimeout(function(){flip('design');},6400);
  }

  // Expertise tabs (ARIA tabs, arrow keys)
  var lens=root.querySelector('[data-ppd-lens]');
  if(lens){
    var tabs=[].slice.call(lens.querySelectorAll('[role=tab]'));
    var show=function(t,focus){tabs.forEach(function(x){var on=x===t;x.setAttribute('aria-selected',on?'true':'false');x.tabIndex=on?0:-1;var p=document.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=!on;});if(focus)t.focus();if(t.scrollIntoView&&window.innerWidth<990){var bar=t.parentElement;bar.scrollTo({left:t.offsetLeft-16,behavior:reduce?'auto':'smooth'});}};
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(){show(t);});
      t.addEventListener('keydown',function(e){var k=e.key,j=-1;if(k==='ArrowDown'||k==='ArrowRight')j=(i+1)%tabs.length;else if(k==='ArrowUp'||k==='ArrowLeft')j=(i-1+tabs.length)%tabs.length;else if(k==='Home')j=0;else if(k==='End')j=tabs.length-1;if(j>-1){e.preventDefault();show(tabs[j],true);}});
    });
  }

  // Concept-to-print stepper
  var flow=root.querySelector('[data-ppd-flow]');
  if(flow){
    var btns=[].slice.call(flow.querySelectorAll('.ppd-flow__btn'));
    var stage=flow.querySelector('.ppd-flow__stage');
    var cur=1,timer=null,DUR=4000,auto=!reduce,visible=false;
    flow.style.setProperty('--dur',DUR+'ms');
    var go=function(n){cur=n;stage.setAttribute('data-step',n);btns.forEach(function(b){var on=+b.getAttribute('data-step')===n;b.setAttribute('aria-pressed',on?'true':'false');b.classList.remove('is-on');if(on){void b.offsetWidth;b.classList.add('is-on');}});};
    var schedule=function(){clearTimeout(timer);if(auto&&visible)timer=setTimeout(function(){go(cur%btns.length+1);schedule();},DUR);};
    btns.forEach(function(b){b.addEventListener('click',function(){auto=false;flow.classList.add('is-paused');clearTimeout(timer);go(+b.getAttribute('data-step'));});});
    if('IntersectionObserver' in window){new IntersectionObserver(function(es){visible=es[0].isIntersecting;if(visible){go(cur);schedule();}else clearTimeout(timer);},{threshold:.35}).observe(stage);}
    if(!auto)flow.classList.add('is-paused');
  }

  // Scroll reveal
  if(reduce||!('IntersectionObserver' in window))return;
  root.classList.add('ppd-js');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  root.querySelectorAll('[data-ppd-reveal]').forEach(function(el){io.observe(el);});
  setTimeout(function(){root.querySelectorAll('[data-ppd-reveal]').forEach(function(el){el.classList.add('is-in');});},6000);
})();
